/// NOTE CHECK THE STATE OF mode that it points to the correct API
// defines which instance of api / database to use kp or p9 or pv
import {getTypeDefinition} from '../shared/searcherfields'
import {getFirebaseConfig as getFbc , getApiConfig as getApc, getIsBoss} from '../private/creds';
import cryptoRandomString from 'crypto-random-string';

const versions = {
  version: '0.0.5',
  release: '27',
  localStateVersion: '21',
  build: new Date(2024,9, 21).getTime().toString(32),
  versionKey: 'fid_version'
};

// a change in version should provoke a persistent cache clear
export const isDevelopment = process.env.NODE_ENV === 'development';
// this gets the connection options mode which we'll need to check the version
const {mode} = getApc();
console.log(process.env.NODE_ENV, isDevelopment, mode);

/* crypto changed
export const randomId = () =>
  crypto
    .randomBytes(24)
    .toString('hex');
*/

export const randomId = () => cryptoRandomString({length: 10});

// used to generate version inf.. version changes lead to clearing of persistent cache

export const getVersion = () => {
  const { versions: vs } = settings;
  return  {
    isDevelopment,
    version: vs.version,
    release: vs.release,
    mode,
    build: vs.build,
    localStateVersion: vs.localStateVersion,
    text: `${vs.version}.${vs.release}.${vs.localStateVersion}.${vs.build}.${mode}.${isDevelopment}`
  }
};

// using localstorage as cache
export const getStorage = () => {
  const storage = window.localStorage;
  if (!storage) {
    throw new Error('cant run app on this browser - needs localstorage');
  }
  return storage;
};

// determine which version generated the current local cache
export const getCacheVersion = () => {
  const storage = getStorage();
  if (storage) {
    const v = storage.getItem(settings.versions.versionKey);
    return v ? JSON.parse(v) : null;
  }
};

// make a note of the version generating local cache
export const setCacheVersion = () => {
  const storage = getStorage();
  if (storage) {
    const v = storage.setItem(
      settings.versions.versionKey,
      JSON.stringify(getVersion())
    );
    return v ? JSON.parse(v) : null;
  }
};

// decide whether to wipe cache -
// right now any version change does it but we could make this more fine grained
export const manageVersion = () => {
  // get the current version of the app
  const version = getVersion();
  const cacheVersion = getCacheVersion();
  // this should only happen to me when mxing dev/prod onthe same machine
  if (cacheVersion && cacheVersion.mode !== mode) {
    console.log(
      'warning- cache mode desnt match app mode',
      cacheVersion,
      version,
      mode
    );
  }
  // if the version has changed, wipe the server cache
  const changedVersion =
    !cacheVersion ||
    cacheVersion.localStateVersion !== version.localStateVersion ||
    cacheVersion.version !== version.version ||
    cacheVersion.mode !== mode;

  // if the localstateversion has not changed then we can safely persist the local settings
  // TODO - this is not yet implemented for execution - this is just prep for a future enhancement
  // right now it's all cleared , both apollo local and server
  const preserveLocalState = cacheVersion && version.localStateVersion === cacheVersion.localStateVersion

  // write the update if it's different
  if (!cacheVersion || cacheVersion.text !== version.text) {
    setCacheVersion();
  }

  // to communiocate that the version has changed and return version info
  return {...version, changedVersion, preserveLocalState};
};

// this controls the width (and therefor the height of the player)
const basePlayerWidth = 144;

// various static settings
// no need to put these in the apollo managed store
export const settings = {
  // to force a clear of local storage the version needs to be different
  // changes in the other stuff wont clear local storage
  versions,
  localCacheKey: 'ap-persist',
  elastic: {
    allowedUses: ['film','company','product','brand','person','profession'],
    autoComplete: {
      limit: 50,
      filmToPerson: {
        keyNames: [{
          name: 'name',
          key: 'profession-profession-auto-name',
          filterOn: 'name.raw'
        }, {
          name: 'companyTypeName',
          key: 'profession-company-type-auto-name',
          filterOn: 'companyTypeID'
        }, {
          name: 'companyDepartmentName',
          key: 'profession-department-auto-name',
          filterOn: 'companyDepartmentID'
        }],
        filterNames: [{
          name: 'companyDepartmentID',
          key: 'profession-profession-company-department-id',
          valueKey: 'profession-company-department-id'
        }, {
          name: 'companyTypeID',
          key: 'profession-profession-company-type-id',
          valueKey: 'profession-company-type-id'
        }, {
          name: 'name.raw',
          key: 'profession-profession-name-raw',
          valueKey: "profession-name-raw",
          useModel: true
        }]
      }
    }
  },
  // these are ID values from the database - avoids having to look up each time, but should not be changed in DB
  dbStaticTypes: {
    artworkTypes: {
      callsheet: '489068156579479555',
    },
  },
  callsheets: {
    analysisProgress: {
      timeout: 30 * 60 * 1000
    }
  },
  viLabels: {
    analysisProgress: {
      timeout: 30 * 60 * 1000
    },
    labelTypes: [
      {
        text: 'Frames',
        value: 'frame-label'
      },
      {
        text: 'Shots',
        value: 'shot-label'
      },
      {
        text: 'Segments',
        value: 'segment-label'
      },
      {
        text: 'Text',
        value: 'text'
      },
      {
        text: 'Transcript',
        value: 'transcript'
      },
      {
        text: 'Logos',
        value: 'logo'
      },
      {
        text: 'Tracking',
        value: 'object-label'
      },
      {
        text: 'Shot changes',
        value: 'shot'
      },
      {
        text: 'Explicit content',
        value: 'explicit-content'
      },
      {
        text: 'Faces',
        value: 'face-label'
      },
      {
        text: 'People',
        value: 'person-label'
      },
      {
        text: 'Celebrities',
        value: 'celebrity'
      }
    ]
  },
  tooltips: {
    closeDelay: 10,
    transition: "slide-x-transition"
  },
  spots: {
    opacities: {
      past: 0.3,
      future: 1
    },
    framesPerSpot: 10,
    defaultFps: 25
  },
  materialColors: [
    "f44336",
    "e81e63",
    "9c27b0",
    "673ab7",
    "3f51b5",
    "2196f3",
    "03a9f4",
    "00bcd4",
    "009688",
    "4caf50",
    "8bc34a",
    "cddc39",
    "ffeb3b",
    "ffc107",
    "ff9800",
    "ff5722",
    "795548",
    "9e9e9e",
    "607d8b"
  ],
  itemTypes: {
    // these are the max possible supported searches for each item type and you can pick less of them in the search box
    searchVariableTypes: {
      film: ['film', 'person', 'company', 'brand', 'product', 'award'],
      person: ['film', 'person', 'company', 'award'],
      company: ['film', 'person', 'company', 'brand', 'product'],
      brand: ['film', 'company', 'brand', 'product'],
      product: ['film', 'company', 'brand', 'product'],
      award: ['film', 'person', 'award'],
      profession:[]
    },

    // these same icons are are used everywhere to represent these things
    icons: {
      close: 'close',
      film: 'movie',
      person: 'person',
      company: 'domain',
      brand: 'copyright',
      product: 'fastfood',
      award: 'thumb_up',
      vimeouser: 'person',
      vimeofilm: 'movie',
      user: 'person',
      defaultframe: 'movie_filter',
      thumbnails: 'photo_album',
      undo: 'undo',
      undoall: 'cached',
      redo: 'redo',
      trash: 'delete',
      moveall: 'arrow_upward',
      login: 'login',
      logout: 'logout',
      confidence: 'all_inclusive',
      start: 'cloud',
      upload: 'cloud_upload',
      label: 'label',
      vilabel: 'book',
      ready: 'build',
      error: 'error',
      showinbrowser: 'open_in_new',
      edit: 'edit',
      delete: 'delete',
      cloudactivity: 'cloud',
      ocr: 'scanner',
      language: 'assignment',
      couple: 'assessment',
      register: 'save_alt',
      done: 'cloud_done',
      rerun: 'refresh',
      waiting: 'cloud',
      expired: 'timer_off',
      detail: 'read_more',
      hide: 'keyboard_arrow_up',
      show: 'keyboard_arrow_down',
      details: 'read_more',
      download: 'cloud_download',
      videolabel: 'video_label',
      pick: 'touch_app',
      assigned: 'assignment',
      waitassign: 'assignment_late',
      ff: 'fast_forward',
      stop: 'stop',
      play: 'play_arrow',
      converting: 'content_copy'
    },
    // these same colors are used everywhere to represent these things
    chipColors: {
      film: 'blue',
      person: 'pink',
      company: 'green',
      brand: 'purple lighten-2',
      product: 'deep-orange darken-2',
      award: 'cyan',
      vimeouser: '#03A9F4',
      vimeofilm: 'blue',
      user: 'blue-grey',
      hls: 'red',
      sd: 'light-blue',
      hd: 'teal',
      ar: 'accent',
      fr: 'cyan',
      br: 'blue-grey',
      seek: 'amber darken-3',
      progress: 'accent',
      done: 'green',
      none: 'amber darken-3',
      slideCount: 'green',
      disabled: 'grey',
      defaultframe: 'yellow',
      undo: 'accent',
      redo: 'accent',
      undoall: 'accent',
      vimeodefaultframe: 'light-green',
      trash: 'red',
      moveall: 'accent',
      labels: 'accent',
      vi: 'teal',
      vicurrent: 'accent',
      confidence: 'accent',
      ready: 'accent',
      ocr: 'accent',
      language: 'accent',
      couple: 'accent',
      register: 'accent',
      cloudactivity: 'accent',
      label: 'accent',
      start: 'amber',
      waiting: 'amber',
      expired: 'red',
      upload: 'accent',
      detail: 'accent',
      hide: '',
      show: '',
      close: '',
      details: 'primary',
      download: 'accent',
      vilabel: 'accent',
      videolabel: 'accent',
      logout: 'white',
      pick: 'white',
      assigned: 'accent',
      waitassign: 'grey',
      ff: 'accent',
      play: 'accent',
      converting: 'accent'
    },
  },
  // this is the default maximum number of addition items (eg profession) to show in a chip
  maxListShow: 3,
  dimensions: {
    // thats the min size to go for a poster frame artwork
    posterFrameHeight: Math.round((9 * basePlayerWidth) / 16),
    posterFrameWidth: basePlayerWidth,
    // width and height for carousel -- TODO dont know how to make these more responsive for now
    carouselWidth: basePlayerWidth,
    carouselHeight: Math.round((9 * basePlayerWidth) / 16),

    // there's a css for this so if change, then also change the css
    playerWidth: basePlayerWidth,
    playerWidthSm: basePlayerWidth *1/1.44,
    blobIconSm: 20,
    blobIconNormal: 48,
  },
  videos: {
    // the mimetype provided by vimeo is wrong for hls.js to work so patch it
    hlsMimeType: 'application/x-mpegURL',
    // doesnt matter what this number is, as if there are hls available it will always use
    hlsQuality: 0,
  },
  // this is used to control how infinite scrolling behaves
  pagination: {
    scrollDistance: 100,
    limit: 16,
    initialLimit: 24,
    noDataText: 'No matches found',
    noResultsTextLoading: 'Loading more data',
    vimeoInitialLimit: 25,
    vimeoLimit: 25,
    vimeoUserSearchLimit: 100,
    vimeoTinyLimit: 100
  },
};

// generate filters for each itemtype - these are the reasons that make a search qualify
const SearchFilters = Object.keys(settings.itemTypes.searchVariableTypes).map(
  itemType => {
    const value = {
      valueKey: 'matchType',
      value: settings.itemTypes.searchVariableTypes[itemType],
      op: '=',
      __typename: 'Filter',
    };
    return {
      __typename: 'SearchFilter',
      itemType,
      value,
    };
  }
);

// and we'll need a way to find them
export const findSearchFilter = ({itemType}) =>
  SearchFilters.find(f => f.itemType === itemType);

// for elsearchoptions
export const getDefaultSearcherIncludes = ({type}) => {
  const tdef = getTypeDefinition({type})
  return tdef && tdef.defaultIncludes
}
const st = settings.itemTypes.searchVariableTypes
const defaultSearcherIncludes = Object.keys(st)
  .map(f=>{
    const defaultIncludes = getDefaultSearcherIncludes({type:f}).map(g=>{
      g.__typename ='ElDefaultInclude'
      return g
    });
    return {
      __typename: 'ElDefault',
      itemType:f,
      DefaultIncludes: defaultIncludes.length ? defaultIncludes : null
    }
  })
  // because any missing fields screw up apollo local cache
  .filter(f=>f.DefaultIncludes)

export const getStateElDefaults = () => ({
    __typename: 'ElDefaults',
    Defaults: defaultSearcherIncludes,
    // who uses advanced search by default
    // when selected in settings this changes in local state
    ElUses: settings.elastic.allowedUses
})

// set local state defaults
export const defaultState = {
  ElDefaults: getStateElDefaults(),
  SearchVariableFilters: {
    __typename: 'SearchVariableFilters',
    SearchFilters,
  },
  ProviderAuth: {
    __typename: 'ProviderAuth',
    uid: null,
    providerID: null,
    userID: null,
    displayName: null,
    emailVerified: false,
    token: null,
    photoUrl: null,
    email: null,
    isAnonymous: true,
    ready: true,
  },
  Controls: {
    __typename: 'Controls',
    searchText: '',
    showPasswordDialog: false,
    email: '',
    service: '',
    newService: '',
    showLinkDialog: false,
    showForgotDialog: false,
    showVerificationDialog: false,
    refresh: false,
    routerFrom: '',
    routerTo: '',
    playing: '',
    showAppBar: true,
    targetType: 'film',
    vimeoReconnect: false,
    vimeoUserSearchText: null,
    vimeoUserSelectedID: null,
    vimeoVideoSearchText: null,
    showVimeo: false,
    showPersona: false,
    selectedType: 'film',
    saveInProgress: false,
    vimeoNavigateAfterAdd: false,
    autoFilmLabelling: false,
    createVerification: true,
    showViLabelStats: false
  },
  SearchVariables: {
    __typename: 'SearchVariables',
    limit: settings.pagination.limit,
    offset: 0,
    value: '',
    filters: findSearchFilter({itemType: 'film'}).value,
    itemType: 'film',
  },
  Toaster: {
    __typename: 'Toaster',
    header: '',
    message: '',
    color: '',
    type: '',
    mobile: false,
    showToaster: false,
  },
};

// from private stuff

export const isBoss = (userID) => getIsBoss(userID);

// cur down version of envmodes for server side apps.
export const getApiConfig= () => getApc()
export const getFirebaseConfig= () => getFbc()

export const getIcon = itemType => settings.itemTypes.icons[itemType];
export const getIconColor = (itemType, disabled) =>
  settings.itemTypes.chipColors[disabled ? 'disabled' : itemType];
export const getMaterialColor = (index) => '#' + settings.materialColors[index % settings.materialColors.length];
export const getLocalCacheKey = () => settings.localCacheKey;
